<template>
  <div class="contact-info--row">
    <div  v-if="isPhoneNumber" class="contact-info--phone">
      <woot-phone-input
            v-if="encryptPhoneNumber !== null"
            :mask="true"            
            :value="href.replace('tel:', '')"
            :readonly="true"
            :encrypt="encryptPhoneNumber"
          />
      <woot-button
        v-if="allowCopy"
        type="submit"
        variant="clear"
        size="tiny"
        color-scheme="secondary"
        icon="clipboard"
        class-names="copy-icon"
        @click="onCopy"
      />
    </div>
    
    <a v-else-if="href" :href="href" class="contact-info--details">
      <emoji-or-icon :icon="icon" :emoji="emoji" icon-size="14" />
      <span v-if="value" class="text-truncate" :title="value">{{ value }}</span>
      <span v-else class="text-muted">{{
        $t('CONTACT_PANEL.NOT_AVAILABLE')
      }}</span>

      <woot-button
        v-if="allowCopy"
        type="submit"
        variant="clear"
        size="tiny"
        color-scheme="secondary"
        icon="clipboard"
        class-names="copy-icon"
        @click="onCopy"
      />
    </a>

    <div v-else class="contact-info--details">
      <emoji-or-icon :icon="icon" :emoji="emoji" icon-size="14" />
      <span v-if="value" class="text-truncate">{{ value }}</span>
      <span v-else class="text-muted">{{
        $t('CONTACT_PANEL.NOT_AVAILABLE')
      }}</span>
    </div>
  </div>
</template>
<script>
import alertMixin from 'shared/mixins/alertMixin';
import agentMixin from 'dashboard/mixins/agentMixin';

import EmojiOrIcon from 'shared/components/EmojiOrIcon';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

export default {
  components: {
    EmojiOrIcon,
  },
  mixins: [alertMixin, agentMixin],
  props: {
    href: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      required: false,
    },
    emoji: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      default: '',
    },
    showCopy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPhoneNumber(){
      return this.href && this.href.startsWith('tel:');
    },
    allowCopy() {
      return this.showCopy && (!this.isPhoneNumber || (this.encryptPhoneNumber !== null && this.encryptPhoneNumber === false));
    },
    encryptPhoneNumber() {
      if(this.currentRole == 'administrator' || this.agentList.length > 0){
        return this.isPhoneNumber && this.agentRules?.mask_number === false;
      }
      return null;
    }    
  },
  methods: {
    async onCopy(e) {
      e.preventDefault();
      await copyTextToClipboard(this.value);
      this.showAlert(this.$t('CONTACT_PANEL.COPY_SUCCESSFUL'));
    },
  },
};
</script>
<style scoped lang="scss">
.contact-info--row {
  margin-top: var(--space-smaller);

  .contact-info--icon {
    font-size: var(--font-size-default);
    min-width: var(--space-medium);
  }
}

.contact-info--details {
  margin-bottom: var(--space-small);
  color: var(--color-body);

  .copy-icon {
    margin-left: var(--space-smaller);
  }

  &.a {
    &:hover {
      text-decoration: underline;
    }
  }
}

.contact-info--details .icon--emoji,
.contact-info--details .icon--font {
  display: inline-block;
  width: var(--space-medium);
}
</style>

<style lang="scss">
  .contact-info--row {  
    .contact-info--phone{
      max-width: 300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .phone-input{
        margin: 0;
        input[readonly]{
          background: none;
        }
      }      
    }
  }
</style>
